import {
	SEARCH_LIST_ADD,
	SEARCH_LIST_SET,
	SEARCH_LIST_FINISHED,
	SEARCH_LIST_SKIP,
	SEARCH_LIST_LOADING,
	SEARCH_FILTER_SET,
	SEARCH_SORTERS_SET,
	SEARCH_FILTER_DATA, 
	SEARCH_LIST_TOTAL
} from '../../actions/pages/search'

const initialState = {
	list: [],
	filterVo: null,
	sorters: [],
	skip: 0,
	finished: false,
	loading: false,
	filterData: null,
	total: 0
}

export default (state = initialState, action) => {
	switch (action.type){
		case SEARCH_LIST_SET:
			return {...state, list: action.payload}
		case SEARCH_LIST_ADD:
			return {...state, list: [...(state.list||[]), ...(action.payload||[])]}
		case SEARCH_LIST_SKIP:
			return {...state, skip: action.payload}
		case SEARCH_LIST_FINISHED:
			return {...state, finished: action.payload}
		case SEARCH_LIST_LOADING:
			return {...state, loading: action.payload}
		case SEARCH_FILTER_SET:
			return {...state, filterVo: action.payload}
		case SEARCH_SORTERS_SET:
			return {...state, sorters: action.payload}
		case SEARCH_FILTER_DATA:
			return {...state, filterData: action.payload}	
		case SEARCH_LIST_TOTAL:
			return { ...state, total: action.payload }
		default:
			return state
	}
}